import { useEffect } from 'react';

export function useWindowEvent<K extends string>(
  type: K,
  listener: K extends keyof WindowEventMap
    ? (this: Window, ev: WindowEventMap[K]) => void
    : (this: Window, ev: CustomEvent) => void,
  options?: boolean | AddEventListenerOptions
) {
  useEffect(() => {
    globalThis.addEventListener(type as never, listener, options);
    return () => globalThis.removeEventListener(type as never, listener, options);
  }, [type, listener, options]);
}
